module.exports = __webpack_public_path__ + "logo-harz-energie.jpg?360168c8e9a61ece1509ed78d98268ef";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-harz-energie.jpg
// module id = 384
// module chunks = 0